import React, { Fragment, useRef } from 'react';
import { translate } from '../Services/translation';
import LanguageSelector from './LanguageSelector';

const NavigationItem = ({ links = [], contentLink = null, isSecondLevel = false, navigationInfo = {} }) => {
  const menuRef = useRef(null);

  const { registerUrl, loginUrl, isLoggedIn } = navigationInfo;

  const toggleMenu = (e) => {
    e.preventDefault();
    menuRef.current.classList.toggle('navbar__menu--show');

    const dropdown = document.getElementById("dropdown");
    const menu = document.getElementById("menu");

    if (dropdown) {
      // Toggle dropdown
      dropdown.classList.toggle('show');

      // Special case: If current element is the menu button, we toggle the child "dropdown" element to skip the first menu item as dropdown and show the child elements instead.
      if (menuRef.current.id === menu.id) {
        dropdown.classList.toggle('navbar__menu--show');
      }
    }
  };

  const closeMenu = (e) => {
    e.preventDefault();

    // Special case to close desktop dropdown
    const dropdown = document.getElementById("dropdown");

    if (dropdown) {
      dropdown.classList.remove("show");
    }

    const elements = document.getElementsByClassName("navbar__menu");

    for (let i = 0; i < elements.length; i++) {
      elements[i].classList.remove("navbar__menu--show");
    }
  };

  const additionClass =
    contentLink && contentLink.attributes
      ? contentLink.attributes.cssValue
      : null;
  const selectedClass =
    contentLink && contentLink.isSelected ? 'navbar__link--selected' : '';
  const hasChildrenClass = links.length > 0 ? 'has-children' : null;
  const hasNameOrChildren = (link) =>
    link.name || (link.links || []).length > 0;

  return (
    <Fragment>
      {!contentLink ? (
        <div className='navbar__burger-menu-container' onClick={toggleMenu}>
          <a
            className="navbar__burger-menu-icon"
            rel="nofollow"
            href="#"
            title={translate('general.menu') || 'menu'}
          ></a>
          <div className='navbar__burger-menu-title'>{translate('general.menu')}</div>
        </div>
      ) : (
        <Fragment>
          <a
            className={`navbar__link ${contentLink.isMegaMenu ? 'hidden' : ''} ${selectedClass} ${hasChildrenClass || ''
              } ${additionClass || ''}`}
            href={contentLink.url || '#'}
            dangerouslySetInnerHTML={{ __html: contentLink.name }}
          ></a>
          {links.length > 0 && !contentLink.isMegaMenu && (
            <i
              onClick={toggleMenu}
              className="navbar__icon--caret-right navbar__icon navbar__icon--open"
            ></i>
          )}
        </Fragment>
      )}

      {links.length > 0 && (
        <div className={"navbar__menu"} ref={menuRef} id={isSecondLevel ? "dropdown" : !contentLink ? "menu" : ""}>
          <div className="navbar__menu-header">
            {!contentLink ? (
              <span
                className="navbar__icon navbar__icon--close"
                onClick={closeMenu}
              ></span>
            ) : (
              <Fragment>
                {!isSecondLevel && <i
                  className="navbar__icon--caret-left navbar__icon"
                  onClick={toggleMenu}
                ></i>}
                <span className="icon-rco-logo"></span>
                <div className='navbar__language-selector-mobile'><LanguageSelector /></div>
                <div className='navbar__dropdown-mobile'><span className='navbar__icon--close-container' onClick={closeMenu}><span className='navbar__icon--close-dropdown'></span></span></div>
              </Fragment>
            )}
          </div>

          {isSecondLevel && <div className='navbar__dropdown-top'><span onClick={closeMenu}><span className='navbar__icon--close-dropdown'></span><span className='navbar__icon--close-dropdown-text'>{translate("dropdown.close")}</span></span></div>}

          <ul className="navbar__menu-links">
            {links.length > 0 &&
              links.map(
                (link, index) =>
                  hasNameOrChildren(link) && (
                    <li className="navbar__item" key={index}>
                      <NavigationItem links={link.links} contentLink={link} isSecondLevel={link.isMegaMenu} navigationInfo={navigationInfo} />
                    </li>
                  )
              )}
          </ul>

          {!isLoggedIn && <div className='navbar__dropdown-button-container'>
            <a className='menu-signup' href={registerUrl}>{translate("dropdown.requestregister")}</a>
            <a className='menu-login' href={loginUrl}>{translate("dropdown.login")}</a>
          </div>}
        </div>
      )}
    </Fragment>
  );
};

export default NavigationItem;